/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: currentPlayers.ts
 *
 * Written by Sterios Taskudis <sterios.taskudis@egt-digital.com> on  25.10.23 12:02 pm.
 * Last modified: 25.10.23 12:02 pm.
 *
 * More information at: https://egt-digital.com/
 */

import { getGamesCurrentPlayersUrl } from '../config';
import store from '../eventStore';
import IGameCurrentPlayers from '../interfaces/IGamesCurrentPlayers';

export const getGamesCurrentPlayersStats = async () => {
    const currentSettings = store.SETTINGS.value;
    const url = getGamesCurrentPlayersUrl(currentSettings.apiHost);

    try {
        const data: IGameCurrentPlayers = await fetch(url).then(res => res.json());
        store.COMMUNICATION_CHANNEL.next({
            event: 'currentPlayers',
            currentPlayers: data || {},
        });
    } catch (e) {
        // Do nothing for now
    }
};
